

import hooks from '../../actions/hooks';

import { setControls, setControlsStatus } from '.';

import { setTempControls, setSaved } from './tempControls';


export const saveControls = (token) => async (dispatch, getState) => {
	// console.log("did we get a token:", token);
	const { tempControls } = getState();

	// console.log("what are tempControls:", tempControls);
	dispatch(setControlsStatus('saving_changes'));
	try {


		const payload = tempControls.list;

		// console.log("do we have payload:", payload);

		await hooks.put('/update/controls', tempControls.list, token);
		dispatch(setControlsStatus('changes_saved'));
		setTimeout(function() {
			console.log('setting dormant');
			dispatch(setControlsStatus('dormant'));
			console.log("not calling setSaved?");
			dispatch(setSaved());
		}, 1500);
		
	} catch (error) {
		dispatch(restoreControls());
		console.error("\txx error saving controls:", error);
	}
};



export const restoreControls = () => (dispatch, getState) => {
	const currentControls = getState().controls.list;
	dispatch(setTempControls(currentControls));
	dispatch(setControlsStatus('restored'));
	setTimeout(() => dispatch(setControlsStatus('dormant')), 0);
};


export const setBothControls = (controls) => (dispatch) => {
	// console.log('what came in as controls:', controls)
	dispatch(setControls(controls));
	dispatch(setTempControls(controls));
};